// extracted by mini-css-extract-plugin
export var chevron = "index-v2-module--chevron--ea66e";
export var contactInfo = "index-v2-module--contactInfo--38e2f";
export var isMobileLink = "index-v2-module--isMobileLink--697ed";
export var links = "index-v2-module--links--b1cde";
export var schoolMeta = "index-v2-module--schoolMeta--3f8f8";
export var schoolMetaRTLContainer = "index-v2-module--schoolMetaRTLContainer--16f6d";
export var servicesTabRTL = "index-v2-module--servicesTabRTL--f72b8";
export var strapAlign = "index-v2-module--strapAlign--07f8d";
export var wrapText = "index-v2-module--wrapText--8f6b4";